(function () {
    /*
    Makes call to the server to get the mini-cart data from either the cart in session or the persisted cart,
    then updates the local storage and refreshes the display.
    Skip while on givingCart pages.
     */
    window.refreshMiniCartFromServer = function (callback) {
        if (location.pathname.indexOf('givingCart.html') > -1) {
            return;
        }
        const e = document.createElement('script');
        e.src = secureBaseURL + 'donors/mini_cart.html?callback=' + ((callback) || 'refreshMiniCartFromServerCallback');
        e.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(e);
    };

    // JSONP callback
    window.refreshMiniCartFromServerCallback = function (obj) {
        const miniCartDetails = (obj != null && obj.data != null && obj.data.cart != null) ? obj.data.cart : null;
        updateMiniCartLocalStorage(miniCartDetails);

        if (obj != null && obj.data != null && obj.data.accountCredits != null) {
            eraseCookie('accountCredits');
            saveAndDisplayAccountCredits(obj.data.accountCredits);
        } else {
            displayAccountCreditsTip();
        }
        updateMiniCartDisplay(obj);
        $(window).trigger('miniCartUpdated');
    };

    /*
    Retrieves the mini-cart data from either the server or from local storage and then refreshes the display.
    When retrieving the data from the server, the local storage data is also updated.
    Called by keepalive.jsp
     */
    window.refreshMiniCartFromServerOrLocalStorage = function () {
        if (location.pathname.indexOf('givingCart.html') > -1) {
            return;
        }
        if (isNonBlankCookie('userId') && isNonBlankCookie('cartUUID')) {
            console.log('refreshMiniCartFromServer');
            refreshMiniCartFromServer();
        } else {
            // otherwise get a miniCartDetails object from local storage data, or create one based on cartUUID
            const miniCartDetailsPromise = getMiniCartDetailsFromLocalStorageData();

            miniCartDetailsPromise.then(function (miniCartDetails) {
                if (miniCartDetails.hasItems) {
                    const obj = { data: { cart: miniCartDetails } };
                    updateMiniCartDisplay(obj);
                } else if (isNonBlankCookie('userId') || isNonBlankCookie('cartUUID')) {
                    refreshMiniCartFromServer();
                }
            });
        }
    };

    /*
    Given a mini-cart details object, updates the local storage and refreshes the display.
    Used by other JS and JSPs
     */
    window.refreshMiniCartFromDetailsObject = function (miniCartDetails) {
        updateMiniCartLocalStorage(miniCartDetails);
        displayAccountCreditsTip();
        const miniCartObj = { data: { cart: miniCartDetails } };
        updateMiniCartDisplay(miniCartObj);
    };

    /*
    Updates the mini-cart local storage from a miniCartDetails object.
     */
    function updateMiniCartLocalStorage(miniCartDetails) {
        if (isSafari()) {
            eraseCookie('miniCartDetails');
        } else {
            dcLocalStorage.setCrossDomainValue('miniCartDetails', '[]');
        }

        eraseCookie('cartGiftCodeAmount');

        if (miniCartDetails) {
            const encodedMiniCartData = window.btoa(encodeURIComponent(JSON.stringify(miniCartDetails)));

            if (isSafari()) {
                createCookie('miniCartDetails', encodedMiniCartData, 60);
            } else {
                dcLocalStorage.setCrossDomainValue('miniCartDetails', encodedMiniCartData);
            }

            // The cartGiftCodeAmount cookie is also created from the gift code redemption page
            // and I'm leaving it as a standalone cookie to be consistent.
            createCookie('cartGiftCodeAmount', miniCartDetails.cartGiftCodeAmount);
        }
    }

    /*
    Updates the mini-cart display, given a "wrapped" version of the miniCartDetails object
     */
    function updateMiniCartDisplay(obj) {
        const hideCartBanner = function () { $('#mainHeader, #mobile-header').removeClass('cart-on'); };
        const showCartBannerWithMessage = function (cartItems, message) {
            $('#mainHeader, #mobile-header').addClass('cart-on');
            $('.mini-cart').attr('data-value', cartItems);
            cartItems > 0 && $('.mini-cart').addClass('enabled');
            $('.cart-message').html(message);
        };
        const rawDollarAmount = function (dollarString) {
            return (dollarString) ? Number(dollarString.replace('$', '')) : 0;
        };

        let cart = obj.data.cart;
        if (!cart) {
            cart = {};
            cart.cartItems = 0;
        }
        const cartHasSpendingItems = Number(cart.cartItems) > 0;

        if (pageName == 'Checkout (View)') {
            $('.mini-cart').addClass('checkout');
        }

        if (!cartHasSpendingItems) {
            if (cart.promoCode) {
                showPromoCodeRedemptionBanner(cart.promoCode);
            }
        } else { // show the banner with the appropriate message
            const giftCodeRedemptionTotal = rawDollarAmount(cart.cartGiftCodeAmount);
            if (giftCodeRedemptionTotal > 0) {
                $('.credit-banner .banner-content').html('To use your <strong>$' + giftCodeRedemptionTotal +
                    " gift card credits</strong>, complete your donation and we'll automatically apply your credits at checkout.");
                $('.credit-banner').show();
            } else {
                const hasPositiveSpendingAmount = rawDollarAmount(cart.cartTotal);
                if (hasPositiveSpendingAmount) {
                    let bannerMessage = formatCurrency(cart.cartTotal, true) + ' for ' + cart.cartItems + ' classroom' + (cart.cartItems === 1 ? '' : 's');

                    const teacherScreenNameIsSet = !!cart.teacherScreenName;
                    if (teacherScreenNameIsSet) {
                        bannerMessage = formatCurrency(cart.cartTotal, true) + ' for ' + cart.teacherScreenName + "'s classroom";
                    }

                    showCartBannerWithMessage(cart.cartItems, bannerMessage);
                }
            }
        }

        $(window).trigger('cartBannerUpdated');
    }

    /*
    Returns a mini-cart details object from the encoded JSON data stored in local storage, or from the cookie if
    the user is using Safari.

    Note that the local storage can go out of sync in cross-device scenarios. If that is ever an issue,
    we could have a version of this method that always gets the MiniCartDetails from server data.

    This function was incorrectly calling dcodeURIComponent (missing "e") in the else branch for a very long time.
    That should've meant it wasn't really doing anything and just erroring out.
    Sue fixed the typo in the if branch, but not the else
    https://github.com/donorsChoose/donorschoose-web/commit/09c3fbc5b4367967cfef6350e2481b6897993dbb
    Is it even needed?
     */
    window.getMiniCartDetailsFromLocalStorageData = function () {
        return new Promise(function (resolve, reject) {
            if (isSafari()) {
                const miniCartData = readCookie('miniCartDetails');
                const decodedMiniCartData = (miniCartData !== undefined && miniCartData != null) ? window.atob(decodeURIComponent(miniCartData)) : null;
                resolve(new MiniCartDetails(decodedMiniCartData));
            } else {
                dcLocalStorage.requestCrossDomainValue('miniCartDetails', function (key, value) {
                    const miniCartData = value;
                    const decodedMiniCartData = (miniCartData !== undefined && miniCartData != null) ? window.atob(decodeURIComponent(miniCartData)) : null;
                    resolve(new MiniCartDetails(decodedMiniCartData));
                });
            }
        });
    };

    // Only used here and in miniCartDetails.js
    window.isSafari = function () {
        return navigator.userAgent.indexOf('Safari') > -1;
    };

    // Only used in header2.js
    window.resetMiniCartForSignOut = function () {
        if (isSafari()) {
            eraseCookie('miniCartDetails');
        } else {
            dcLocalStorage.setCrossDomainValue('miniCartDetails', '[]');
        }

        updateMiniCartDisplay({ data: { cart: '[]' } });
    };

    function showPromoCodeRedemptionBanner(promoCode) {
        $('#promo-code-redemption-message').html('Your promo code <strong>' + promoCode + '</strong> has been successfully applied and will be reflected in checkout.');
        $('#promo-code-redemption-banner').show();
    }
})();
